import { loadable } from '../../../components/loadable';
import { Spinner } from '../../../components/Spinner/Spinner';

export const LoadableCertificationSetup = loadable(
  () => import('./ConnectedCertificationSetup'),
  {
    loading: Spinner,
    key: 'ConnectedCertificationSetup',
  }
);
